import styled, { keyframes } from 'styled-components';
import { Input, Table } from 'reactstrap';

export const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const StudentsContainer = styled.div`
  padding: 20px;
  animation: ${fadeIn} 0.5s ease-out;
`;

export const FormWrapper = styled.div`
  margin-bottom: 20px;
  border: 2px solid #ccc;
  padding: 15px;
`;

export const StyledButton = styled.button`
  padding: 10px 10px;
  background: linear-gradient(135deg, #007bff, #0056b3);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 20px;
  box-shadow: 0 4px 8px rgba(0, 123, 255, 0.3);
  transition: all 0.3s ease;

  &:hover {
    background: linear-gradient(135deg, #0056b3, #007bff);
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(0, 123, 255, 0.4);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    background: linear-gradient(135deg, #6c757d, #5a6268);
    cursor: not-allowed;
    box-shadow: none;
    transform: none;
  }
`;

export const StyledTableHeader = styled.th`
  background-color: #f0f0f0;
  color: #333;
`;

export const TooltipWrapper = styled.div`
  position: relative;
  cursor: pointer;
  color: black;
  text-decoration: underline;

  /* Khi hover, tooltip sẽ xuất hiện */
  &:hover > .tooltip-content {
    display: block;
  }
`;

export const TooltipContent = styled.div`
  display: none;  /* Mặc định ẩn */
  position: absolute;
  top: -30px;
  left: 50%;
  transform: translateX(-50%);
  padding: 5px;
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  border-radius: 3px;
  font-size: 12px;
  white-space: normal; /* Cho phép xuống dòng */
  word-wrap: break-word; /* Quản lý việc xuống dòng trong trường hợp nội dung dài */
  z-index: 10;
  max-width: 500px; /* Giới hạn chiều rộng tối đa nếu cần */
  min-width: 100px; /* Chiều rộng tối thiểu */
  width: auto; /* Tự động điều chỉnh chiều rộng theo nội dung */
`;


export const HeaderButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;

  .buttons-and-search {
    display: flex;
    align-items: center;
    gap: 10px; /* Khoảng cách giữa các phần tử */
  }
`;

export const FilterInput = styled(Input)`
  width: 300px;
  padding: 8px;
  font-size: 16px;
  border: 2px solid #007bff; /* Viền đậm màu xanh */
  border-radius: 5px;
  outline: none;

  &:focus {
    border-color: #0056b3;
    box-shadow: 0 0 5px rgba(0, 91, 187, 0.5);
  }
`;

export const TableContainer = styled.div`
  position: relative;
  max-height: 80vh; /* Chiều cao tối đa cho vùng cuộn */
  overflow-y: auto; /* Cho phép cuộn dọc phần dữ liệu */
`;

export const StyledTable = styled(Table)`
  width: 100%;
  border-collapse: collapse;

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    border-bottom: 2px solid #ccc;
    padding: 8px; /* Khoảng cách giữa nội dung và viền */
    text-align: left; /* Căn trái nội dung */
  }

  tbody tr:nth-child(odd) {
    background-color: #f0f8ff; /* Nền xanh nhạt cho dòng lẻ */
  }

  tbody tr:nth-child(even) {
    background-color: white; /* Nền trắng cho dòng chẵn */
  }

  tbody td {
    padding: 8px; /* Khoảng cách giữa nội dung và viền */
    max-width: 200px; /* Giới hạn độ rộng cột */

    /* Tự xuống dòng khi quá dài */
    white-space: normal;
    word-wrap: break-word;      /* Hỗ trợ trình duyệt cũ */
    overflow-wrap: break-word;  /* Chuẩn mới hơn */
    border: 0.5px solid #ccc; /* Đường viền ngăn cách cột */
  }
`;

export const StudentCountContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1em;
  cursor: default;
  user-select: none;

  span {
    display: flex;
    align-items: center;
    gap: 4px;
    transition: transform 0.2s ease, font-weight 0.2s ease;
  }

  .active {
    color: #28a745;
  }

  .pending {
    cursor: pointer;
    color: #ff9800;

    &.active {
      transform: scale(1.15);
      font-weight: bold;
    }

    &:hover {
      transform: scale(1.1);
    }
  }

  .new-month {
    cursor: pointer;
    color: #007bff;

    &.active {
      transform: scale(1.15);
      font-weight: bold;
      color: #007bff;
    }

    &:hover {
      transform: scale(1.1);
    }
  }
`;

export const StudentName = styled.span`
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  transition: transform 0.2s ease, font-weight 0.2s ease;

  &:hover {
    transform: scale(1.05);
    font-weight: bold;
  }
`;

// Modal Button Styles
export const WarningButton = styled.button`
  padding: 8px 16px;
  background: linear-gradient(135deg, #ffc107, #ff9800);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  box-shadow: 0 4px 8px rgba(255, 193, 7, 0.3);
  transition: all 0.3s ease;

  &:hover {
    background: linear-gradient(135deg, #ff9800, #ffc107);
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(255, 193, 7, 0.4);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const DangerButton = styled.button`
  padding: 8px 16px;
  background: linear-gradient(135deg, #dc3545, #c82333);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  box-shadow: 0 4px 8px rgba(220, 53, 69, 0.3);
  transition: all 0.3s ease;

  &:hover {
    background: linear-gradient(135deg, #c82333, #dc3545);
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(220, 53, 69, 0.4);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const PrimaryButton = styled.button`
  padding: 10px 20px;
  background: linear-gradient(135deg, #007bff, #0056b3);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  box-shadow: 0 4px 8px rgba(0, 123, 255, 0.3);
  transition: all 0.3s ease;

  &:hover {
    background: linear-gradient(135deg, #0056b3, #007bff);
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(0, 123, 255, 0.4);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    background: linear-gradient(135deg, #6c757d, #5a6268);
    cursor: not-allowed;
    box-shadow: none;
    transform: none;
  }
`;

export const SecondaryButton = styled.button`
  padding: 10px 20px;
  background: linear-gradient(135deg, #6c757d, #545b62);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  box-shadow: 0 4px 8px rgba(108, 117, 125, 0.3);
  transition: all 0.3s ease;

  &:hover {
    background: linear-gradient(135deg, #545b62, #6c757d);
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(108, 117, 125, 0.4);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const SuccessButton = styled.button`
  padding: 10px 20px;
  background: linear-gradient(135deg, #28a745, #20c997);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  box-shadow: 0 4px 8px rgba(40, 167, 69, 0.3);
  transition: all 0.3s ease;

  &:hover {
    background: linear-gradient(135deg, #20c997, #28a745);
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(40, 167, 69, 0.4);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    background: linear-gradient(135deg, #6c757d, #5a6268);
    cursor: not-allowed;
    box-shadow: 0 2px 4px rgba(108, 117, 125, 0.2);
    opacity: 0.65;
    
    &:hover {
      background: linear-gradient(135deg, #6c757d, #5a6268);
      transform: none;
      box-shadow: 0 2px 4px rgba(108, 117, 125, 0.2);
    }
  }
`;

export const InfoButton = styled.button`
  padding: 6px 12px;
  background: linear-gradient(135deg, #17a2b8, #138496);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  box-shadow: 0 4px 8px rgba(23, 162, 184, 0.3);
  transition: all 0.3s ease;

  &:hover {
    background: linear-gradient(135deg, #138496, #17a2b8);
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(23, 162, 184, 0.4);
  }

  &:active {
    transform: translateY(0);
  }
`;
